"use client";

export default function Error() {
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center">
      <h2 className="text-3xl text-primary-600">Something went wrong!</h2>
    </div>
  );
}
